import colors from '@/design/colors';
import { HeadingLarge, HeadingSmall, Text } from '@/design/typography';
import styled from 'styled-components';

export const PrintSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  > h2 {
    ${HeadingLarge(16)};
    color: ${colors.blackAlpha200};
    display: flex;
    align-items: center;
    column-gap: 12px;
  }
`;

export const PrintItemContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  width: fit-content;
`;

export const PrintItemTitle = styled.h3`
  ${HeadingSmall(14)};
  color: ${colors.blackAlpha200};
`;

export const PrintItemSubtitle = styled.span`
  ${Text(14)};
  color: ${colors.gray300};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const PrintSectionDivider = styled.hr`
  border: none;
  border-top: 1px solid ${colors.gray100};
  margin: 16px 0;
`;

export const PrintActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 16px;
  margin-top: 16px;

  > button {
    min-width: 133px;
  }
`;
